import cx from 'clsx';

import { InputOverrideClassNames } from '../textinput';
import { InputStyleProps } from '../types';

import MonthPickerInputClasses from './MonthPickerInput.module.css';

export const MonthPickerInputOverrideClassNames = (props: InputStyleProps) => {
  const dateInputClasses = InputOverrideClassNames(props);
  return {
    ...InputOverrideClassNames(props),
    input: cx(dateInputClasses.input, MonthPickerInputClasses.input),
    monthsListControl: MonthPickerInputClasses.monthsListControl,
    calendarHeaderLevel: MonthPickerInputClasses.calendarHeaderLevel,
    calendarHeaderControl: MonthPickerInputClasses.calendarHeaderControl
  };
};
